import { defineMessages } from 'react-intl';

export default defineMessages({
  adult: {
    id: 'booking.ticket.type.adult',
    defaultMessage: 'Adult',
  },
  child: {
    id: 'booking.ticket.type.child',
    defaultMessage: 'Child',
  },
  infant: {
    id: 'booking.ticket.type.infant',
    defaultMessage: 'Infant',
  },
  price: {
    id: 'booking.ticket.price',
    // eslint-disable-next-line no-template-curly-in-string
    defaultMessage: '- ${price}',
  },
});
